module.exports = {"210811001":"老边街道","210811002":"城东街道","210811101":"路南镇","210811102":"柳树镇","210811103":"边城镇","210811400":"营口辽河经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210811.json
// module id = 561
// module chunks = 0